import React, {Fragment, useState, useEffect} from 'react';
import {Button} from '../main/Styles/Toolbar.jsx';
import axios from 'axios';

import {PROD_UPDATE_SERVER_URL, CONNECTION_STATE} from './StateConstants.jsx';
import PropTypes from 'prop-types';


const RootCertPage = (props) => {
  RootCertPage.propTypes = {
    setState: PropTypes.func.isRequired,
    updateURL: PropTypes.string.isRequired,
    isSSWP: PropTypes.bool.isRequired
  };

  const [fileURL, setFileURL] = useState(null);

  const getFileUrl = () => {
    const updateURL = props.updateURL? props.updateURL: PROD_UPDATE_SERVER_URL;
    axios.get(`${updateURL}/Resources/Update2.xml`, {params: {
      t: new Date().getTime()
    }}).then((cUpdateServerResponse) => {
      if (cUpdateServerResponse.status !== 200) {
        console.log(`load ${updateXML}/Resources/Update2.xml failed`);
        return Promise.reject(Error(cUpdateServerResponse.status));
      }
      return cUpdateServerResponse.data;
    }).catch((e) => {
      logError(e);
      return Promise.reject(new ScannerFirmwareUpdateError(`Cannot connect to update server - ${e.message}`));
    }).then((cText) => {
      const updateDoc = new DOMParser().parseFromString(cText, 'application/xml');
      const fPath = [...updateDoc.getElementsByTagName('RootCertificate')].map((firmwareElem) => {
        return firmwareElem.getElementsByTagName('FilePath')[0].textContent;
      });
      console.log(`filePath: ${fPath}`);
      setFileURL(`${updateURL}/Resources/${fPath}`);
    }).catch(() => null);
  };

  useEffect(getFileUrl, []);

  return (
    <Fragment>
      {props.isSSWP && <div>
        <div>
          If you have experimented connection problems probably
        </div>
        <p/>
      </div>}

      <div>
        Your application requires the installation of a Security Certificate in<br/>
        order to connect with the scanner.<br/><p/>
        You will need admin privilegies to install the certificate.<p/><p/>
      </div>
      <p/>
      <div>
        {props.isSSWP && <Button variant="contained" color="primary"
            onClick={() => {
              console.log('skip');
              props.setState(CONNECTION_STATE.UPDATE_HAS_CANCELED);
            }}
        >
          Skip
        </Button>}
        &nbsp;&nbsp;&nbsp;&nbsp;

        <a href={fileURL} download >
          <Button variant="contained" color="primary"
            onClick={() => {
              console.log(`Download root cert from ${fileURL}`);
              if (props.isSSWP) {
                props.setState(CONNECTION_STATE.UPDATE_HAS_CANCELED);
              }
            }}
          >
            Download the RDM Root Certificate
          </Button>
        </a>
        {/* &nbsp;&nbsp;&nbsp;
        <Button variant="contained" color="primary">
          Try again
        </Button> */}
      </div>
    </Fragment>
  );
};

export default RootCertPage;
